import { createAsyncAction } from 'Reducks/reduxActions';

export const getRecordingReportAction = createAsyncAction('GET_RECORDING_REPORT');
